import React from 'react';
import PropTypes from 'prop-types';

class FilterRectCheckbox extends React.Component {

    shouldComponentUpdate(nextProps) {
        let curProps = this.props;

        if (curProps.value !== nextProps.value) {
            return true;
        }

        if (curProps.classes !== nextProps.classes) {
            return true;
        }

        if (curProps.disabled !== nextProps.disabled) {
            return true;
        }

        return false;
    }

    onClick = (e) => {
        this.props.onClick(e, this.props.item);
    };

    render() {
        let {
            label,
            value,
            disabled,
        } = this.props;

        return <div className={`filter-rect-checkbox ${value && 'checked'} ${disabled && 'disabled'}`} onClick={this.onClick}>
            <span>{label}</span>
        </div>;
    }
}


FilterRectCheckbox.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export default FilterRectCheckbox;
